import {
  Component,
  Input,
  OnInit,
  Output,
  ViewChild,
  EventEmitter,
  SimpleChanges,
  OnChanges,
  ChangeDetectionStrategy
} from "@angular/core";
import { StructureTableAnagraph_AnagraphDirective } from "src/directive/structure-table-anagraph-anagraph.directive";
import { StructureTableAnagraph_TableDirective } from "src/directive/structure-table-anagraph-table.directive";
import { EventService } from "src/service/event.service";

@Component({
    selector: "app-structure-table-anagraph",
    templateUrl: "./structure-table-anagraph.component.html",
    styleUrls: ["./structure-table-anagraph.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StructureTableAnagraphComponent implements OnInit, OnChanges {
  @Input("AnagraphTitle") AnagraphTitle: string = "";
  @Input("TableComponentSelector") TableComponentSelector: string = "";
  @Input("AnagraphComponentSelector") AnagraphComponentSelector: string = "";
  @Input("allowDetectionListChange") allowDetectionListChange: boolean = true;
  @Output("OnSelectedObject") OnSelectedObject = new EventEmitter<any>();
  @Output("OnClickPreview") OnClickPreview = new EventEmitter<any>();
  @Input("showPreview") showPreview: boolean = false;
  /**Ref. to directive "structure-table-anagraph-table.directive";
   * This directive is used to build (and manage) in the LEFT area of the component a "table" sub-component containing the list of objects whose information are "expanded"
   * in the RIGHT area. This sub-component may vary (hence the use of the Directive), but it is an extension of "GenericTableAnagraphTable.ts".
   */
  @ViewChild(StructureTableAnagraph_TableDirective, { static: true })
  componentHostTable: StructureTableAnagraph_TableDirective;

  /**Ref. to directive "structure-table-anagraph-anagraph.directive";
   * This directive is used to build (and manage) in the RIGHT area of the component a "anagraph" sub-component displaying the "expanded" information of one
   * object, selected from the list in the RIGHT area. This sub-component may vary (hence the use of the Directive), but it is an extension of "GenericTableAnagraphAnagraph.ts".
   */
  @ViewChild(StructureTableAnagraph_AnagraphDirective, { static: true })
  componentHostAnagraph: StructureTableAnagraph_AnagraphDirective;

  public _currentSelectedObject: any = null;
  public _anagraphColor: string = "light";

  constructor(private _eventService: EventService) {}

  ngOnInit() {
    this.componentHostTable.drawTableComponent(this.TableComponentSelector);

    this.componentHostAnagraph.drawAnagraphComponent(
      this.AnagraphComponentSelector
    );
    this._eventService.OnForceCloseAnagraphPanel.subscribe((forceClose) => {
      if (forceClose) {
        this.onClickCloseHeaderAnagraph();
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    this.componentHostTable.ChangeDetectionList(this.allowDetectionListChange);
  }

  /**
   * Close the anagraph panel (containing object "GenericTableAnagraphAnagraph.component" or extension, on the RIGHT)
   */
  public onClickCloseHeaderAnagraph() {
    this._currentSelectedObject = null;
    this.componentHostAnagraph.ChangeCurrentObject(this._currentSelectedObject);
    this.componentHostTable.ChangeCurrentObject(this._currentSelectedObject);
    this.OnSelectedObject.emit(this._currentSelectedObject);
    window.dispatchEvent(new Event("resize"));
  }

  /**
   * Show preview of components
   */
  public onClickShowPreview() {
    this.OnClickPreview.emit(this._currentSelectedObject);
  }

  /**
   * When an object is selected from the table list (object "GenericTableAnagraphTable.component" or extension, on the LEFT)
   * propagate the information to the anagraph table (object "GenericTableAnagraphAnagraph.component" or extension, on the RIGHT)
   * @param object
   */
  public changedSelectedObject(object: any) {
    this._currentSelectedObject = object;
    this.componentHostTable.ChangeCurrentObject(this._currentSelectedObject);
    this.componentHostAnagraph.ChangeCurrentObject(this._currentSelectedObject);
    this.OnSelectedObject.emit(this._currentSelectedObject);
    window.dispatchEvent(new Event("resize"));
  }

  /**
   * This method order the "refresh" of the entire "Anagraph" sub-component.
   * This is done deleting the existing HTML object and re-drawing it with the directive, passing to it the already specified child-class of
   * "GenericTableAnagraphAnagraph" (defined in "AnagraphComponentSelector"). The previous selected object is then displayed again.
   *
   * EXAMPLE OF USE: Rebuild the component when localisation language changes, in order to localize all sub-component.
   */
  public refreshAnagraph() {
    this.componentHostAnagraph.drawAnagraphComponent(
      this.AnagraphComponentSelector
    );

    this.componentHostAnagraph.ChangeCurrentObject(this._currentSelectedObject);
  }
}
